export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-22.3bbb53c6.png";